import _ from 'underscore';

export const arrayToCsv = (array: any, spaces?: boolean) => {
	if (!array) return '';

	if (_.isString(array)) return array;

	return _.map(array, (v) => `"${v}"`).join(',' + (spaces ? ' ' : ''));
};

export default arrayToCsv;
